/* eslint-disable */
import _ from "lodash/fp";
import React, { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Controller, useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  enableOTPButton,
  generateCaptcha,
  generateOTP,
  getBoardsList,
  getDigilockerFlagAPI,
  getGenderDropdownValues,
  getIdTypeDropdownValues,
  verificationOfOTP
} from "../../common/actions/commonActions";
import ModuleHide from "../../common/components/ModuleHide";
import PasswordMeter from "../../common/components/PasswordMeter";
import {
  aadhaarNumber,
  email,
  maskname,
  mobile,
  oneCapitalLetterRegex,
  oneNumberRegex,
  oneSpecialCharacterRegex,
  panCardRegex,
  securityQuestionRegex
} from "../../common/constants/regex";
import commonLabels from "../../common/labels/common_en.json";
import commonHILabels from "../../common/labels/common_hi.json";
import { OAS_API_BASE_URL } from "../../configuration";
import { fromUTCDate, getFormattedDate, preventDateManualTyping, toUTCDate } from "../../helpers/Datetime";
import "../../styles/advertisementTable.css";
import "../../styles/home.css";
import "../../styles/modal.css";
import "../../styles/profile.css";
import "../../styles/registration.css";
import {
  getSecurityQuestions,
  registerCandidate,
} from "../actions/registrationActions";

function Registration(props) {
  const {
    register,
    handleSubmit,
    watch,
    formState,
    errors,
    control,
    setError,
    setValue,
    reset,
    getValues,
    clearErrors
  } = useForm({
    mode: "onChange",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getSecurityQuestions());
    dispatch(getBoardsList());
    // dispatch(generateCaptcha());
    dispatch(getGenderDropdownValues());
    dispatch(getIdTypeDropdownValues());
    dispatch(getDigilockerFlagAPI());
  }, []);

  const questions = useSelector(
    (state) => state.registration.securityQuestions
  );
  const captchaId = useSelector((state) => state.common.captchaId);
  const boardsList = useSelector((state) => state.common.boardsList);
  const digilockerFlg = useSelector((state) => state.common.digilockerFlg);
  const [confirmPasswordFlag, setConfirmPasswordFlag] = useState(false);

  const [otpDisableForEmail, setotpDisableForEmail] = useState(false);
  const [otpDisableForMobile, setotpDisableForMobile] = useState(false);
  const [selectedtype, setSelectedType] = useState();
  
  let {
    genderDropdownList,
    idTypeDropdownList,
    emailOTPResponse,
    mobileOTPResponse,
    moduleDetails,
    isApiCallForModule,
    mobileNoAlreadyExistFlg,
    emailIdAlreadyExistFlg,
  } = useSelector((state) => state.common, shallowEqual);
  const verifyOTPFlagRegistrationEmail = useSelector(
    (state) => state.common.verifyOTPFlagRegistrationEmail
  );
  const verifyOTPFlagRegistrationMobile = useSelector(
    (state) => state.common.verifyOTPFlagRegistrationMobile
  );
  
  const passwordEntered = watch("password");
  const userName = watch("userName");
  const mobileNumber = watch("mobileNumber");
  const { emailOtpData, mobileOtpData } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  let enteredEmailOtp = watch("otp_email");
  let enteredMobileOtp = watch("otp_mobile");
  const currentDomain = window.location.hostname;
  const matchingBaseUrl =
  OAS_API_BASE_URL &&
  OAS_API_BASE_URL.find((item) => item.key === currentDomain)?.baseUrl;
  const captchaImageUrl = `${matchingBaseUrl}/oas/api/v1/otps/${captchaId}`;
  // const idTypeLookupId = watch("idTypeLookupId");
  const [idTypeLookupId, setIdTypeLookupId] = useState('')
  const genderLookupId = watch("gender");
  const [idTypeLabel, setIdTypeLabel] = useState("");
  const [genderLabel, setGenderLabel] = useState("");
  const [verifyCandidateNameFlag, setVerifyCandidateNameFlag] = useState(false)
  const [verifyCandidateFatherNameFlag, setVerifyCandidateFatherNameFlag] = useState(false)
  const [verifyCandidateMotherNameFlag, setVerifyCandidateMotherNameFlag] = useState(false)
  const [verifyCandidateDOBFlag, setVerifyCandidateDOBFlag] = useState(false)
  const [verifyGenderFlag, setVerifyGenderFlag] = useState(false)
  const [verifyAadharFlag, setVerifyAadharFlag] = useState(false)
  const [verifyPanNoFlag, setVerifyPanNoFlag] = useState(false)
  const [verifyDrivingLicenceFlag, setVerifyDrivingLicenceFlag] = useState(false)
  const [unmaskCandidateNameValue, setUnmaskCandidateNameValue] = useState("");
  const [unmaskCandidateFatherNameValue, setUnmaskCandidateFatherNameValue] = useState("");
  const [unmaskCandidateMotherNameValue, setUnmaskCandidateMotherNameValue] = useState("");
  const [unmaskAadharValue, setUnmaskAadharValue] = useState("");
  const [unmaskPanValue, setUnmaskPanValue] = useState("");
  const [unmaskDrivingLicenceValue, setUnmaskDrivingLicenceValue] = useState("");
  const [unmaskAadharValueErr, setUnmaskAadharValueErr] = useState(false);
  const [unmaskPanValueErr, setUnmaskPanValueErr] = useState("");
  const [unmaskDrivingLicenceValueErr, setUnmaskDrivingLicenceValueErr] = useState("");
  
  const [reloadItem, setReloadItem] = useState(0);
  const [showInstructionsModal, setShowInstructionsmodal] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  
  const toggleModal = () => {
    setShowModal(false)
    setShowInstructionsmodal(false)
  }

  useEffect(() => {
    if (verifyOTPFlagRegistrationEmail && verifyOTPFlagRegistrationMobile) {
      dispatch(generateCaptcha());
    }
    if (verifyOTPFlagRegistrationMobile) {
      setotpDisableForMobile(true);
    }
    if (verifyOTPFlagRegistrationEmail) {
      setotpDisableForEmail(true)
    }
  }, [verifyOTPFlagRegistrationEmail, verifyOTPFlagRegistrationMobile, otpDisableForEmail, otpDisableForMobile])

  useEffect(() => {
    if (!isApiCallForModule) {
      // dispatch(checkModuleEnableDisable("USER_REGISTRATION"));
    }
  }, [isApiCallForModule]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const preventClipboardActions = (event) => {
      if (event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA") {
        event.preventDefault();
      }
    };
    document.addEventListener("copy", preventClipboardActions);
    document.addEventListener("cut", preventClipboardActions);
    document.addEventListener("paste", preventClipboardActions);
    return () => {
      document.removeEventListener("copy", preventClipboardActions);
      document.removeEventListener("cut", preventClipboardActions);
      document.removeEventListener("paste", preventClipboardActions);
    };
  }, []);

  const startTimerMail = parseInt(emailOtpData.expiryDuration);
  const startTimerMob = parseInt(mobileOtpData.expiryDuration);

  useEffect(() => {
    startTimeCount(selectedtype);
  }, [emailOtpData]);
  useEffect(() => {
    startTimeCount(selectedtype);
  }, [mobileOtpData]);

  useEffect(() => {
    if (mobileNoAlreadyExistFlg) {
      setotpDisableForMobile(false);
    }
  }, [mobileNoAlreadyExistFlg]);

  useEffect(() => {
    if (emailIdAlreadyExistFlg) {
      setotpDisableForEmail(false);
    }
  }, [emailIdAlreadyExistFlg]);

  useEffect(() => {
    if (
      idTypeDropdownList &&
      idTypeDropdownList.lookupOptionDtoList &&
      idTypeDropdownList.lookupOptionDtoList.length > 0
    ) {
      const matchedItem = idTypeDropdownList.lookupOptionDtoList.find(
        (item) => item.id == idTypeLookupId
      );
      if (matchedItem && matchedItem) {
        setIdTypeLabel(matchedItem.label);
      } else {
        setIdTypeLabel("");
      }
    }
  }, [idTypeLookupId, idTypeDropdownList]);

  useEffect(() => {
    if (
      genderDropdownList &&
      genderDropdownList.lookupOptionDtoList &&
      genderDropdownList.lookupOptionDtoList.length > 0
    ) {
      const matchedItem = genderDropdownList.lookupOptionDtoList.find(
        (item) => item.id == genderLookupId
      );
      if (matchedItem && matchedItem) {
        setGenderLabel(matchedItem.label);
      } else {
        setGenderLabel("");
      }
    }
  }, [genderLookupId, genderDropdownList]);

  const startTimeCount = (type) => {
    if (type === "email") {
      let start = startTimerMail;
      function displayTime() {
        let end = start - 1;
        start = end;
        let element = document.getElementById("emailTimer");
        if (element) {
          element.textContent = start;
        }
        if (start == 0) {
          clearInterval(createClock);
          setotpDisableForEmail(false);
        }
      }
      const createClock = setInterval(displayTime, 1000);
    }

    if (type === "mobile") {
      let start = startTimerMob;
      function displayTime() {
        let end = start - 1;
        start = end;
        let element = document.getElementById("mobileTimer");
        if (element) {
          element.textContent = start;
        }
        if (start == 0) {
          clearInterval(createClock);
          setotpDisableForMobile(false);
        }
      }
      const createClock = setInterval(displayTime, 1000);
    }
  };

  const getOTP = (email, mobile, type) => {
    dispatch(
      generateOTP({
        email: email,
        mobile: mobile,
        type: type,
        otpFor: "register",
        getOtpOnlyFor: "email",
        isForgotPassword: false,
      })
    );
    if (email != "") {
      dispatch(enableOTPButton("registration-email"));
      setValue("otp_email", "", { shouldDirty: true });
      setotpDisableForEmail(true);
      setSelectedType(type);
    }
    if (mobile != "") {
      dispatch(enableOTPButton("registration-mobileNumber"));
      setValue("otp_mobile", "", { shouldDirty: true });
      setotpDisableForMobile(true);
      setSelectedType(type);
    }
    setValue("password", "", { shouldDirty: true });
    setValue("confirmPassword", "", { shouldDirty: true });
  };

  const checkValidity = (evt, value) => {
    if (evt && evt.target && evt.target.name) {
      if (evt.target.name === "confirmPassword") {
        if (evt.target.value === watch("password")) {
          setConfirmPasswordFlag(false);
        } else {
          setConfirmPasswordFlag(true);
        }
      }

      if (evt.target.name === "verifyCandidateName") {
        let currentValue = evt.target.value.toUpperCase();
        let upperCaseValue = unmaskCandidateNameValue.toUpperCase();
        if (currentValue === upperCaseValue) {
          setVerifyCandidateNameFlag(false);
        } else {
          setVerifyCandidateNameFlag(true);
        }
      }

      if (evt.target.name === "verifyCandidateFatherName") {
        let currentValue = evt.target.value.toUpperCase();
        let upperCaseValue = unmaskCandidateFatherNameValue.toUpperCase();
        if (currentValue === upperCaseValue) {
          setVerifyCandidateFatherNameFlag(false);
        } else {
          setVerifyCandidateFatherNameFlag(true);
        }
      }

      if (evt.target.name === "verifyCandidateMotherName") {
        let currentValue = evt.target.value.toUpperCase();
        let upperCaseValue = unmaskCandidateMotherNameValue.toUpperCase();
        if (currentValue === upperCaseValue) {
          setVerifyCandidateMotherNameFlag(false);
        } else {
          setVerifyCandidateMotherNameFlag(true);
        }
      }

      if (evt.target.name === "verifyGender") {
        if (evt.target.value === watch("gender")) {
          setVerifyGenderFlag(false);
        } else {
          setVerifyGenderFlag(true);
        }
      }

      if (evt.target.name === "verifyAadharNo") {
        if (evt.target.value === unmaskAadharValue) {
          setVerifyAadharFlag(false);
        } else {
          setVerifyAadharFlag(true);
        }
      }

      if (evt.target.name === "verifyPanNo") {
        let currentValue = evt.target.value.toUpperCase();
        let upperCaseValue = unmaskPanValue.toUpperCase();
        if (currentValue === upperCaseValue) {
          setVerifyPanNoFlag(false);
        } else {
          setVerifyPanNoFlag(true);
        }
      }

      if (evt.target.name === "verifyDrivingLicenceNo") {
        let currentValue = evt.target.value.toUpperCase();
        let upperCaseValue = unmaskDrivingLicenceValue.toUpperCase();
        if (currentValue === upperCaseValue) {
          setVerifyDrivingLicenceFlag(false);
        } else {
          setVerifyDrivingLicenceFlag(true);
        }
      }
    }

    if (evt === "verifiedDob") {
      const valueDate = new Date(value);
      const dobDate = new Date(watch("dob"));
      const areDatesEqual =
        valueDate.getFullYear() === dobDate.getFullYear() &&
        valueDate.getMonth() === dobDate.getMonth() &&
        valueDate.getDate() === dobDate.getDate();

      if (areDatesEqual) {
        setVerifyCandidateDOBFlag(false);
      } else {
        setVerifyCandidateDOBFlag(true);
      }
    }
  };

  const verificationOTP = () => {
    let reqBody = {};
    if (enteredEmailOtp) {
      reqBody.username = watch("userName");
      reqBody.otp = enteredEmailOtp;
      reqBody.id = emailOTPResponse.id;
      reqBody.type = emailOTPResponse.type;
      reqBody.otpFor = "register";
      dispatch(verificationOfOTP(reqBody, "registration-email"));
    }
    else {
      setError("otp_email", { type: "required" });
    }
  };
  const verificationOfOTPOnMobile = () => {
    let reqBody = {};
    if (enteredMobileOtp) {
      reqBody.username = watch("mobileNumber");
      reqBody.otp = enteredMobileOtp;
      reqBody.id = mobileOTPResponse.id;
      reqBody.type = mobileOTPResponse.type;
      reqBody.otpFor = "register";
      dispatch(verificationOfOTP(reqBody, "registration-mobileNumber"));
    } else {
      setError("otp_mobile", { type: "required" });
    }
  };


  const getYearList = () => {
    const startYear = commonLabels.COMMON.DROPDOWN_YEAR;
    const currentYear = new Date().getFullYear();
    return Array.from(
      { length: startYear + 1 },
      (v, i) => (
        <option key={i} value={currentYear - i}>
          {currentYear - i}
        </option>
      )
    );
  };
  // const handleTextChange = (evt) => {
  //   const inputValue = evt.target.value;
  //   const inputName = evt.target.name;

  //   const handleUnmaskingAndMasking = (value, setUnmaskValue, setValueFn) => {
  //     if (!value) {
  //       setUnmaskValue("");
  //       setValueFn(inputName, "");
  //       return;
  //     }

  //     const lastCharacter = value.charAt(value.length - 1);
  //     const isBackspace = evt.nativeEvent.inputType === "deleteContentBackward";
  //     const isSpaceKey = lastCharacter === " ";

  //     setUnmaskValue((prevUnmaskValue) => {
  //       if (isBackspace) {
  //         return prevUnmaskValue.slice(0, -1); 
  //       } else if (isSpaceKey) {
  //         return prevUnmaskValue + " "; 
  //       } else if (value.length === 1) {
  //         return value; 
  //       } else if (lastCharacter === "*") {
  //         return prevUnmaskValue; 
  //       } else {
  //         return prevUnmaskValue + lastCharacter; 
  //       }
  //     });

  //     const masked = value
  //       .split("")
  //       .map((char, index) => (char === " " ? " " : index === 0 ? char : "*"))
  //       .join("");
  //     setValueFn(inputName, masked);
  //   };

  //   switch (inputName) {
  //     case "candidateName":
  //       handleUnmaskingAndMasking(inputValue, setUnmaskCandidateNameValue, setValue);
  //       break;
  //     case "candidateFatherName":
  //       handleUnmaskingAndMasking(inputValue, setUnmaskCandidateFatherNameValue, setValue);
  //       break;
  //     case "candidateMotherName":
  //       handleUnmaskingAndMasking(inputValue, setUnmaskCandidateMotherNameValue, setValue);
  //       break;
  //     case "aadharNo":
  //       handleUnmaskingAndMasking(inputValue, setUnmaskAadharValue, setValue);
  //       break;
  //     case "panNo":
  //       handleUnmaskingAndMasking(inputValue, setUnmaskPanValue, setValue);
  //       break;
  //     case "drivingLicenceNo":
  //       handleUnmaskingAndMasking(inputValue, setUnmaskDrivingLicenceValue, setValue);
  //       break;
  //     default:
  //       break;
  //   }
  // };
  const handleTextChange = (evt) => {
    const inputValue = evt.target.value.trim();
    const inputName = evt.target.name;

    const handleUnmasking = (value, setUnmaskValue) => {
      let uppercaseVal = value && value.toUpperCase();
      setUnmaskValue(uppercaseVal);
    };

    const handleMasking = (value, setValueFn) => {
      if (!value) {
        setValueFn(inputName, "");
        return;
      }

      const masked = value
        .split("")
        .map((char, index) => (char === " " ? " " : index === 0 ? char : "X"))
        .join("");
      setValueFn(inputName, masked);
    };

    switch (inputName) {
      case "candidateName":
        handleUnmasking(inputValue, setUnmaskCandidateNameValue);
        break;
      case "candidateFatherName":
        handleUnmasking(inputValue, setUnmaskCandidateFatherNameValue);
        break;
      case "candidateMotherName":
        handleUnmasking(inputValue, setUnmaskCandidateMotherNameValue);
        break;
      case "aadharNo":
        handleUnmasking(inputValue, setUnmaskAadharValue);
        break;
      case "panNo":
        handleUnmasking(inputValue, setUnmaskPanValue);
        break;
      case "drivingLicenceNo":
        handleUnmasking(inputValue, setUnmaskDrivingLicenceValue);
        break;
      default:
        break;
    }
  };

  const handleBlur = (evt) => {
    const inputValue = evt.target.value.trim();
    const inputName = evt.target.name;

    const handleMasking = (value, setValueFn) => {
      if (!value) {
        setValueFn(inputName, "");
        return;
      }
      const masked = value
        .split("")
        .map((char, index) => (char === " " ? " " : index === 0 ? char : "X"))
        .join("");
      setValueFn(inputName, masked);
    };

    switch (inputName) {
      case "candidateName":
        handleMasking(inputValue, setValue);
        break;
      case "candidateFatherName":
        handleMasking(inputValue, setValue);
        break;
      case "candidateMotherName":
        handleMasking(inputValue, setValue);
        break;
      case "aadharNo":
        handleMasking(inputValue, setValue);
        break;
      case "panNo":
        handleMasking(inputValue, setValue);
        break;
      case "drivingLicenceNo":
        handleMasking(inputValue, setValue);
        break;
      default:
        break;
    }
  };

  // useEffect(() => {
  //   if (unmaskAadharValue) {
  //     if (!aadhaarNumber.test(unmaskAadharValue)) {
  //       setUnmaskAadharValueErr(true);
  //     } else {
  //       setUnmaskAadharValueErr(false);
  //     }
  //   } else if (!unmaskAadharValue) {
  //     setUnmaskAadharValueErr(false);
  //   }

  //   if (unmaskPanValue) {
  //     if (!panCardRegex.test(unmaskPanValue.toUpperCase())) {
  //       setUnmaskPanValueErr(true);
  //     } else {
  //       setUnmaskPanValueErr(false);
  //     }
  //   } else if (!unmaskPanValue) {
  //     setUnmaskPanValueErr(false)
  //   }

  //   if (unmaskDrivingLicenceValue) {
  //     if (!drivingLicenseRegex.test(unmaskDrivingLicenceValue)) {
  //       setUnmaskDrivingLicenceValueErr(true);
  //     } else {
  //       setUnmaskDrivingLicenceValueErr(false);
  //     }
  //   } else if (!unmaskDrivingLicenceValue) {
  //     setUnmaskDrivingLicenceValueErr(false)
  //   };

  // }, [unmaskAadharValue, unmaskPanValue, unmaskDrivingLicenceValue]);

  const values = getValues();
  const [allFieldsFilled, setAllFieldsFilled] = useState(false);
  const watchedValues = watch();

  useEffect(() => {
    const filled = Object.values(getValues()).every(
      (val) => typeof val === "string" ? val.trim() !== "" : true
    );
    setAllFieldsFilled(filled);
  }, [watch, values, watchedValues]);

  useEffect(() => {
    if (idTypeLookupId == commonLabels.DATABASE_VALUES.AADHAR_CARD_LOOKUP_ID) {
      if (unmaskAadharValue) {
        setUnmaskAadharValueErr(!aadhaarNumber.test(unmaskAadharValue));
      } else {
        setUnmaskAadharValueErr(false);
      }
    }

    if (idTypeLookupId == commonLabels.DATABASE_VALUES.PAN_CARD_LOOKUP_ID) {
      if (unmaskPanValue) {
        setUnmaskPanValueErr(!panCardRegex.test(unmaskPanValue.toUpperCase()));
      } else {
        setUnmaskPanValueErr(false);
      }
    }

    // if (idTypeLookupId == commonLabels.DATABASE_VALUES.DL_LOOKUP_ID ) {
    //   if (unmaskDrivingLicenceValue) {
    //     setUnmaskDrivingLicenceValueErr(!drivingLicenseRegex.test(unmaskDrivingLicenceValue));
    //   } else {
    //     setUnmaskDrivingLicenceValueErr(false);
    //   }
    // }
  }, [
    idTypeLookupId,
    unmaskAadharValue,
    unmaskPanValue,
    unmaskDrivingLicenceValue
  ]);

  useEffect(() => {
    if (idTypeLookupId === "518" || idTypeLookupId === "519") {
      setShowModal(true)
    }
  }, [idTypeLookupId])


  
  const handleCheckboxChange = (e) => {
    setIsAgreed(e.target.checked);
  };

  // useEffect(()=>{
  //   setReloadItem(!reloadItem)
  // },[reloadItem]);

  return moduleDetails.isEnabled == false ? < ModuleHide details={moduleDetails} /> :
    (
      // <form onSubmit={handleSubmit((data) => { dispatch(registerCandidate(data, props, captchaId, emailOTPResponse, mobileOTPResponse, enteredEmailOtp, enteredMobileOtp, navigate)) })}>
      <form className="d-flex scrollable-section" onSubmit={handleSubmit((data) => { dispatch(registerCandidate(data, props, captchaId, emailOTPResponse, mobileOTPResponse, enteredEmailOtp, enteredMobileOtp, navigate, genderLabel, idTypeLabel, mobileNumber, userName)) })}>
        <div className="col-sm-12 col-md-7">
          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-sm-12 col-md-11 mt-4">

              <div className="text-center">
                <span className="bold-text f20 fw-semibold">{commonLabels.SIGN_UP.ONE_TIME_REGISTERATION}</span>
                <div className="dotted-line"></div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.FORGOT_RESET_PASSWORD.EMAIL_ID}
                    <span className="errorText">*</span>
                  </label>
                  <div className="input-group bg-color">
                    <input
                      className="form-control"
                      id="registrationFormControlInput1"
                      type="text"
                      name="userName"
                      ref={register({
                        required: true,
                        maxLength: 320,
                        pattern: email,
                      })}
                      placeholder={
                        commonLabels.FORGOT_RESET_PASSWORD.ENTER_EMAIL_ID
                      }
                      autoComplete="off"
                      maxLength="50"

                      disabled={verifyOTPFlagRegistrationEmail}
                    />
                    <div className="input-group-text p-0 align-items-initial">
                      <button
                        className="btn btn-secondary f11 ps-4 button-gradient"
                        type="button"
                        id="button-addon2"
                        onClick={() => {
                          getOTP(userName, "", "email");
                        }}
                        disabled={
                          (_.get("userName.type", errors) ? true : false) ||
                          otpDisableForEmail
                        }
                      >
                        {commonLabels.SIGN_UP.Get_OTP}
                      </button>
                    </div>
                  </div>
                  {_.get("userName.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.EMAIL_REQUIRED}
                    </p>
                  )}
                  {_.get("userName.type", errors) === "maxLength" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.EMAIL_MAX_LENGTH}
                    </p>
                  )}
                  {_.get("userName.type", errors) === "pattern" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.EMAIL_PATTERN}
                    </p>
                  )}
                  {otpDisableForEmail &&
                    verifyOTPFlagRegistrationEmail == false ? (
                    <p className="Note">
                      {commonLabels.SIGN_UP.OTP_NOTE}{" "}
                      <span id="emailTimer"></span> {commonLabels.SIGN_UP.SECONDS}
                    </p>
                  ) : (
                    <p className="Note d-none">
                      {commonLabels.SIGN_UP.OTP_NOTE}{" "}
                      <span id="emailTimer"></span> {commonLabels.SIGN_UP.SECONDS}
                    </p>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.EMAIL_OTP_INPUT}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={
                        commonLabels.SIGN_UP.EMAIL_OTP_INPUT_PLACEHOLDER
                      }
                      name="otp_email"
                      id="registrationFormControlInput3"
                      maxLength={6}
                      ref={register({ required: true, maxLength: 6 })}
                      aria-label="emailotp"
                      aria-describedby="button-addon2"
                      autoComplete="off"
                      disabled={verifyOTPFlagRegistrationEmail}
                    />
                    <div className="input-group-text p-0 align-items-initial">
                      <button
                        className="btn btn-secondary f11 button-gradient"
                        type="button"
                        id="button-addon2"
                        onClick={verificationOTP}
                        disabled={verifyOTPFlagRegistrationEmail}
                      >
                        {commonLabels.SIGN_UP.VERIFY_OTP}
                      </button>
                    </div>
                  </div>
                  {_.get("otp_email.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.OTP_REQ}
                    </p>
                  )}
                  {_.get("otp_email.type", errors) === "maxLength" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.OTP_MAX_LENGTH_WARNING}
                    </p> 

                    
                  )}
                  {(
                    <p className="noteText font-style f11">
                      {commonLabels.OTP_MAX_SPAN_WARNING} <span className="f12 text-danger">  spam </span> 
                    </p>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="labelContainer">
                    <label className="LeftText f11 fw-semibold">
                      {commonLabels.SIGN_UP.MOBILE_NO}
                      <span className="noteText">* {commonLabels.COMMON.AADHAR_LINK_NOTE} </span>
                    </label>
                  </div>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      className="form-control"
                      id="registrationFormControlInput2"
                      name="mobileNumber"
                      ref={register({ required: true, pattern: mobile })}
                      placeholder={commonLabels.SIGN_UP.MOBILE_NO_PLACEHOLDER}
                      autoComplete="off"
                      disabled={verifyOTPFlagRegistrationMobile}
                      maxLength={10}
                    />
                    <div className="input-group-text p-0 align-items-initial">
                      <button
                        className="btn btn-secondary ps-4 f11 button-gradient"
                        type="button"
                        id="button-addon2"
                        onClick={() => {
                          getOTP("", mobileNumber, "mobile");
                        }}
                        disabled={
                          (_.get("mobileNumber.type", errors) ? true : false) ||
                          otpDisableForMobile
                        }
                      >
                        {commonLabels.SIGN_UP.Get_OTP}
                      </button>
                    </div>
                  </div>

                  {_.get("mobileNumber.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.MOBILE_REQ}
                    </p>
                  )}
                  {_.get("mobileNumber.type", errors) === "pattern" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.MOBILE_MAX_LENGTH_WARNING}
                    </p>
                  )}
                  {otpDisableForMobile &&
                    verifyOTPFlagRegistrationMobile == false ? (
                    <p className="Note">
                      {commonLabels.SIGN_UP.OTP_NOTE}{" "}
                      <span id="mobileTimer"></span>{" "}
                      {commonLabels.SIGN_UP.SECONDS}
                    </p>
                  ) : (
                    <p className="Note d-none">
                      {commonLabels.SIGN_UP.OTP_NOTE}{" "}
                      <span id="mobileTimer"></span>{" "}
                      {commonLabels.SIGN_UP.SECONDS}
                    </p>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.MOBILE_OTP_INPUT}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={
                        commonLabels.SIGN_UP.MOBILE_OTP_INPUT_PLACEHOLDER
                      }
                      name="otp_mobile"
                      id="registrationFormControlInput4"
                      maxLength={6}
                      ref={register({ required: true, maxLength: 6 })}
                      aria-label="mobileotp"
                      aria-describedby="button-addon2"
                      autoComplete="off"
                      disabled={verifyOTPFlagRegistrationMobile}
                    />
                    <div className="input-group-text p-0 align-items-initial">
                      <button
                        className="btn btn-secondary f11 button-gradient"
                        type="button"
                        id="button-addon2"
                        onClick={verificationOfOTPOnMobile}
                        disabled={verifyOTPFlagRegistrationMobile}
                      >
                        {commonLabels.SIGN_UP.VERIFY_OTP}
                      </button>
                    </div>
                  </div>
                  {_.get("otp_mobile.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.OTP_REQ}
                    </p>
                  )}
                  {_.get("otp_mobile.type", errors) === "maxLength" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.OTP_MAX_LENGTH_WARNING}
                    </p>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.NEW_PASSWORD}
                    <span className="errorText">*</span>
                  </label>
                  <div className="input-group bg-color">
                    <input
                      type="password"
                      className="form-control"
                      placeholder={commonLabels.SIGN_UP.PASSWORD_PLACEHOLDER}
                      id="registrationFormControlInput5"
                      name="password"
                      disabled={
                        !verifyOTPFlagRegistrationMobile &&
                        !verifyOTPFlagRegistrationMobile
                      }
                      ref={register({
                        required: true,
                        minLength: 8,
                        maxLength: 15,
                        validate: {
                          oneCapitalLetter: (value) =>
                            oneCapitalLetterRegex.test(value),
                          oneNumber: (value) =>
                            oneNumberRegex.test(value),
                          oneSpecialCharacter: (value) =>
                            oneSpecialCharacterRegex.test(value),
                        },
                      })}

                      onChange={(e) => {
                        setValue("confirmPassword", "");
                      }}
                    />
                  </div>
                  {_.get("password.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.NEW_PASSWORD_REQ}
                    </p>
                  )}
                  {_.get("password.type", errors) === "minLength" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.MIN_LENGTH_VALIDATION}
                    </p>
                  )}
                  {_.get("password.type", errors) === "maxLength" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.MAX_LENGTH_VALIDATION}
                    </p>
                  )}
                  {errors.password?.type === "oneCapitalLetter" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.MIN_ONE_CAPITAL_LETTER}
                    </p>
                  )}
                  {errors.password?.type === "oneNumber" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.MIN_ONE_NUMBER}
                    </p>
                  )}
                  {errors.password?.type === "oneSpecialCharacter" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.MIN_ONE_SPECIAL_CHAR}
                    </p>
                  )}
                  <PasswordMeter password={passwordEntered} />
                </div>
                <div className="col-md-6">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.CONFIRM_PASSWORD}
                    <span className="errorText">*</span>
                  </label>
                  <div className="input-group bg-color">
                    <input
                      type="password"
                      placeholder={
                        commonLabels.SIGN_UP.CONFIRM_PASSWORD_PLACEHOLDER
                      }
                      className="form-control"
                      id="registrationFormControlInput6"
                      name="confirmPassword"
                      disabled={
                        !verifyOTPFlagRegistrationMobile &&
                        !verifyOTPFlagRegistrationMobile
                      }
                      ref={register({ required: true, maxLength: 15 })}
                      onInput={checkValidity}
                    />
                  </div>
                  {_.get("confirmPassword.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.Confirm_Password_is_required}
                    </p>
                  )}
                  {confirmPasswordFlag &&
                    _.get("confirmPassword.type", errors) != "required" ? (
                    <p className="errorText">
                      {commonLabels.SIGN_UP.NEW_PASS_AND_CONFIRM_PASS_NOTE}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 font-weight">
                  <div className="labelContainer">
                    <label className="LeftText f11 fw-semibold">{commonLabels.FORGOT_RESET_PASSWORD.CANDIDATE_NAME}<span className="errorText">*</span> <span className="noteText  font-style">{commonLabels.COMMON.MARKSHEET_NOTE}</span></label>
                  </div>
                  <div className="input-group bg-color">
                    <input
                      className="form-control text-uppercase"
                      id="registrationFormControlInput1"
                      type="text"
                      ref={register({ required: true, pattern: maskname })}
                      name="candidateName"
                      placeholder={commonLabels.FORGOT_RESET_PASSWORD.ENTER_CANDIDATE_NAME}
                      onChange={(e) => {
                        setValue("verifyCandidateName", "");
                        handleTextChange(e)
                      }}
                      autoComplete="off"
                      onBlur={(e) => handleBlur(e)}
                      maxLength={50}
                    />
                  </div>
                  {_.get("candidateName.type", errors) === "required" && (
                    <p className="errorText">{commonLabels.VALIDATE_MESSAGE.FIELD_REQ}</p>
                  )}
                  {_.get("candidateName.type", errors) === "pattern" && (
                    <p className="errorText">{commonLabels.VALIDATE_MESSAGE.ENTER_VALID_NAME}</p>
                  )}

                </div>
                <div className="col-md-6">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.VERIFY_CANDIDATE_NAME}
                    <span className="errorText">*</span>
                  </label>
                  <div className="input-group bg-color">
                    <input
                      className="form-control text-uppercase"
                      id="registrationFormControlInput1"
                      type="text"
                      ref={register({ required: true, pattern: maskname })}
                      name="verifyCandidateName"
                      placeholder={
                        commonLabels.SIGN_UP.VERIFY_CANDIDATE_NAME_PLACEHOLDER
                      }
                      onChange={checkValidity}
                      autoComplete="off"
                      maxLength={50}
                    />
                  </div>
                  {_.get("verifyCandidateName.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("verifyCandidateName.type", errors) === "pattern" && (
                    <p className="errorText">{commonLabels.VALIDATE_MESSAGE.ENTER_VALID_NAME}</p>
                  )}
                  {verifyCandidateNameFlag &&
                    _.get("verifyCandidateName.type", errors) != "required" ? (
                    <p className="errorText">
                      {
                        commonLabels.SIGN_UP
                          .CANDIDATE_NAME_AND_VERIFY_CANDIDATE_NAME
                      }
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="labelContainer">
                    <label className="LeftText f11 fw-semibold">
                      {commonLabels.SIGN_UP.CANDIDATE_FATHER_NAME}
                      <span className="errorText">* </span>
                      <span className="noteText font-style">{commonLabels.COMMON.MARKSHEET_NOTE}</span>
                    </label>
                  </div>
                  <div className="input-group bg-color">
                    <input
                      className="form-control text-uppercase"
                      id="registrationFormControlInput1"
                      type="text"
                      ref={register({ required: true, pattern: maskname })}
                      name="candidateFatherName"
                      onChange={(e) => {
                        setValue("verifyCandidateFatherName", "");
                        handleTextChange(e);
                      }}
                      placeholder={
                        commonLabels.SIGN_UP.CANDIDATE_FATHER_NAME_PLACEHOLDER
                      }
                      autoComplete="off"
                      onBlur={(e) => handleBlur(e)}
                      maxLength={50}
                    />
                  </div>
                  {_.get("candidateFatherName.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("candidateFatherName.type", errors) === "pattern" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.ENTER_VALID_NAME}
                    </p>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.VERIFY_CANDIDATE_FATHER_NAME}
                    <span className="errorText">*</span>
                  </label>
                  <div className="input-group bg-color">
                    <input
                      className="form-control text-uppercase"
                      id="registrationFormControlInput2"
                      type="text"
                      ref={register({ required: true, pattern: maskname })}
                      name="verifyCandidateFatherName"
                      placeholder={
                        commonLabels.SIGN_UP
                          .VERIFY_CANDIDATE_FATHER_NAME_PLACEHOLDER
                      }
                      onChange={checkValidity}
                      autoComplete="off"
                      maxLength={50}
                    />
                  </div>
                  {_.get("verifyCandidateFatherName.type", errors) ===
                    "required" && (
                      <p className="errorText">
                        {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                  {_.get("verifyCandidateFatherName.type", errors) === "pattern" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.ENTER_VALID_NAME}
                    </p>
                  )}
                  {verifyCandidateFatherNameFlag &&
                    _.get("verifyCandidateFatherName.type", errors) !=
                    "required" ? (
                    <p className="errorText">
                      {
                        commonLabels.SIGN_UP
                          .CANDIDATE_FATHER_NAME_AND_VERIFY_FATHER_CANDIDATE_NAME
                      }
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 font-weight">
                  <div className="labelContainer">
                    <label className="LeftText f11 fw-semibold">
                      {commonLabels.SIGN_UP.CANDIDATE_MOTHER_NAME}
                      <span className="errorText">* </span>
                      <span className="noteText font-style">{commonLabels.COMMON.MARKSHEET_NOTE}</span>
                    </label>
                  </div>
                  <div className="input-group bg-color">
                    <input
                      className="form-control text-uppercase"
                      id="registrationFormControlInput1"
                      type="text"
                      ref={register({ required: true, pattern: maskname })}
                      name="candidateMotherName"
                      onChange={(e) => {
                        setValue("verifyCandidateMotherName", "");
                        handleTextChange(e);
                      }}
                      placeholder={
                        commonLabels.SIGN_UP.CANDIDATE_MOTHER_NAME_PLACEHOLDER
                      }
                      autoComplete="off"
                      onBlur={(e) => handleBlur(e)}
                      maxLength={50}
                    />
                  </div>
                  {_.get("candidateMotherName.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("candidateMotherName.type", errors) === "pattern" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.ENTER_VALID_NAME}
                    </p>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.VERIFY_CANDIDATE_MOTHER_NAME}
                    <span className="errorText">*</span>
                  </label>
                  <div className="input-group bg-color">
                    <input
                      className="form-control text-uppercase"
                      id="registrationFormControlInput1"
                      type="text"
                      ref={register({ required: true, pattern: maskname })}
                      name="verifyCandidateMotherName"
                      placeholder={
                        commonLabels.SIGN_UP
                          .VERIFY_CANDIDATE_MOTHER_NAME_PLACEHOLDER
                      }
                      onChange={checkValidity}
                      autoComplete="off"
                      maxLength={50}
                    />
                  </div>
                  {_.get("verifyCandidateMotherName.type", errors) ===
                    "required" && (
                      <p className="errorText">
                        {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                  {_.get("verifyCandidateMotherName.type", errors) === "pattern" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.ENTER_VALID_NAME}
                    </p>
                  )}
                  {verifyCandidateMotherNameFlag &&
                    _.get("verifyCandidateMotherName.type", errors) !=
                    "required" ? (
                    <p className="errorText">
                      {
                        commonLabels.SIGN_UP
                          .CANDIDATE_MOTHER_NAME_AND_VERIFY_MOTHER_CANDIDATE_NAME
                      }
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="labelContainer">
                    <label className="LeftText f11 fw-semibold">
                      {commonLabels.FORGOT_RESET_PASSWORD.CANDIDATE_DOB}
                      <span className="errorText">* </span>
                      <span className="noteText">{commonLabels.COMMON.MARKSHEET_NOTE}</span>
                    </label>
                  </div>
                  <div>
                    <Controller
                      control={control}
                      name="dob"
                      id="registrationFormControlInput7"
                      rules={{ required: true }}
                      render={({ onChange, value }) => (
                        <div className="date-picker-container">
                          <DatePicker
                            className="form-control bg-color ps-2"
                            maxDate={new Date()}
                            showIcon
                            selected={getFormattedDate(value)}
                            onChange={(e) => {
                              onChange(toUTCDate(e));
                              setValue("verifiedDob", "");
                            }}
                            icon={
                              <img
                                src="/icons/calender.png"
                                className="date-picker-icon"
                              ></img>
                            }
                            dateFormat={
                              commonLabels.DATE_FORMAT_LABELS
                                .SMALL_SIZE_DATE_FORMAT
                            }
                            // readOnly
                            onKeyDown={preventDateManualTyping}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText={
                              commonLabels.DATE_FORMAT_LABELS.DATE_FORMAT
                            }
                          />
                        </div>
                      )}
                    />
                    {errors.dob && errors.dob.type === "validate" && (
                      <p className="errorText">{commonLabels.SIGN_UP.AGE_NOTE}</p>
                    )}
                    {_.get("dob.type", errors) === "required" && (
                      <p className="errorText">
                        {commonLabels.VALIDATE_MESSAGE.DOB_REQUIRED}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-md-6 mt-3">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.VEFIRY_CANDIDATE_DOB}
                    <span className="errorText">*</span>
                  </label>
                  <div>
                    <Controller
                      control={control}
                      name="verifiedDob"
                      id="registrationFormControlInput7"
                      rules={{ required: true }}
                      render={({ onChange, value, name }) => (
                        <div className="date-picker-container">
                          <DatePicker
                            className="form-control bg-color ps-2"
                            maxDate={new Date()}
                            showIcon
                            toggleCalendarOnIconClick
                            icon={
                              <img
                                src="/icons/calender.png"
                                className="date-picker-icon"
                              ></img>
                            }
                            selected={fromUTCDate(value)}
                            onChange={(e) => {
                              onChange(toUTCDate(e));
                              checkValidity(name, toUTCDate(e));
                            }}
                            dateFormat={
                              commonLabels.DATE_FORMAT_LABELS
                                .SMALL_SIZE_DATE_FORMAT
                            }
                            onKeyDown={preventDateManualTyping}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText={
                              commonLabels.DATE_FORMAT_LABELS.DATE_FORMAT
                            }
                          />
                        </div>
                      )}
                    />
                    {errors.dob && errors.dob.type === "validate" && (
                      <p className="errorText">{commonLabels.SIGN_UP.AGE_NOTE}</p>
                    )}
                    {_.get("verifiedDob.type", errors) === "required" && (
                      <p className="errorText">
                        {commonLabels.VALIDATE_MESSAGE.DOB_REQUIRED}
                      </p>
                    )}
                    {verifyCandidateDOBFlag &&
                      _.get("verifiedDob.type", errors) != "required" ? (
                      <p className="errorText">
                        {commonLabels.SIGN_UP.CANDIDATE_DOB_AND_VERIFY_DOB}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 font-weight ">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.GENDER}
                    <span className="errorText">*</span>
                  </label>
                  <div className="input-group">
                    <select
                      className="form-select  bg-color"
                      name="gender"
                      ref={register({ required: true })}
                      onChange={(e) => {
                        setValue("verifyGender", "");
                      }}
                    >
                      <option key={0} value="">
                        {commonLabels.SIGN_UP.SELECT}
                      </option>
                      {genderDropdownList &&
                        genderDropdownList.lookupOptionDtoList &&
                        genderDropdownList.lookupOptionDtoList.map((ele, ind) => {
                          return (
                            <option key={ind++} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  {_.get("gender.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.VERIFY_GENDER}
                    <span className="errorText">*</span>
                  </label>
                  <div className="input-group">
                    <select
                      className="form-select bg-color"
                      name="verifyGender"
                      ref={register({ required: true })}
                      onChange={checkValidity}
                    >
                      <option key={0} value="">
                        {commonLabels.SIGN_UP.SELECT}
                      </option>
                      {genderDropdownList &&
                        genderDropdownList.lookupOptionDtoList &&
                        genderDropdownList.lookupOptionDtoList.map((ele, ind) => {
                          return (
                            <option key={ind++} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  {_.get("verifyGender.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {verifyGenderFlag &&
                    _.get("verifyGender.type", errors) != "required" ? (
                    <p className="errorText">
                      {commonLabels.SIGN_UP.GENDER_AND_VERIFY_GENDER}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 ">
                  <label className="LeftText f11 fw-semibold">
                    {commonLabels.SIGN_UP.ID_TYPE}
                    <span className="errorText">*</span>
                  </label>
                  <div className="input-group">
                    <select
                      className="form-select  bg-color"
                      name="idTypeLookupId"
                      ref={register({ required: true })}
                      onChange={(e) => {
                        // setReloadItem(!reloadItem)
                        setValue('idTypeLookupId', e.target.value);
                        setValue('aadharNo', '');
                        setValue('panNo', '');
                        setValue('drivingLicenceNo', '');
                        setValue('verifyAadharNo', '');
                        setValue('verifyPanNo', '');
                        setValue('verifyDrivingLicenceNo', '');
                        clearErrors("aadharNo");
                        clearErrors("panNo");
                        clearErrors("drivingLicenceNo");
                        clearErrors("verifyAadharNo");
                        clearErrors("verifyPanNo");
                        clearErrors("verifyDrivingLicenceNo");
                        setIdTypeLookupId(e.target.value)
                        setUnmaskAadharValueErr(false);
                        setUnmaskPanValueErr(false);
                        // setUnmaskDrivingLicenceValueErr(false);
                        setVerifyPanNoFlag(false);
                        setVerifyDrivingLicenceFlag(false);
                        setVerifyAadharFlag(false);
                        setUnmaskDrivingLicenceValue('');
                        setUnmaskPanValue('');
                        setUnmaskAadharValue('')
                      }}
                    >
                      <option key={0} value="">
                        {commonLabels.SIGN_UP.SELECT}
                      </option>
                      {idTypeDropdownList &&
                        idTypeDropdownList.lookupOptionDtoList &&
                        idTypeDropdownList.lookupOptionDtoList.map((ele, ind) => {
                          return (
                            <option key={ind++} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  {_.get("idTypeLookupId.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                </div>
              </div>
              {/* {idTypeLabel === commonLabels.COMMON.AADHAR_CARD ? ( */}
              {idTypeLookupId == commonLabels.DATABASE_VALUES.AADHAR_CARD_LOOKUP_ID ? (
                <div className="row">
                  <div className="col-md-6">
                    <label className="LeftText f11 fw-semibold">
                      {commonLabels.SIGN_UP.AADHAR_NO}
                      <span className="errorText">*</span>
                    </label>
                    <div className="input-group bg-color">
                      <input
                        className="form-control text-uppercase"
                        id="registrationFormControlInput1"
                        type="text"
                        ref={register({ required: true })}
                        name="aadharNo"
                        placeholder={commonLabels.SIGN_UP.AADHAR_NO_PLACEHOLDER}
                        minLength="12"
                        maxLength="12"
                        autoComplete="off"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, "");
                        }}
                        onChange={(e) => {
                          setValue("verifyAadharNo", "");
                          clearErrors("verifyAadharNo");
                          handleTextChange(e);
                        }}
                        onBlur={(e) => handleBlur(e)}
                      />
                    </div>
                    {_.get("aadharNo.type", errors) === "required" && (
                      <p className="errorText">
                        {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                    {unmaskAadharValueErr && (
                      <p className="errorText">
                        {commonLabels.VALIDATE_MESSAGE.ENTER_VALID_AADHAR_NUMBER}
                      </p>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="LeftText f11 fw-semibold">
                      {commonLabels.SIGN_UP.VERIFY_AADHAR_NO}
                      <span className="errorText">*</span>
                    </label>
                    <div className="input-group bg-color">
                      <input
                        className="form-control text-uppercase"
                        id="registrationFormControlInput1"
                        type="text"
                        ref={register({ required: true })}
                        name="verifyAadharNo"
                        autoComplete="off"
                        placeholder={
                          commonLabels.SIGN_UP.VERIFY_AADHAR_NO_PLACEHOLDER
                        }
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, "");
                        }}
                        onChange={checkValidity}
                        minLength="12"
                        maxLength="12"
                      />
                    </div>
                    {_.get("verifyAadharNo.type", errors) === "required" && (
                      <p className="errorText">
                        {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                    {verifyAadharFlag &&
                      _.get("verifyAadharNo.type", errors) != "required" ? (
                      <p className="errorText">
                        {commonLabels.SIGN_UP.AADHAR_NO_AND_VERIFY_AADHAR_NO}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) :
                // idTypeLabel === commonLabels.COMMON.PAN_CARD ? (
                idTypeLookupId == commonLabels.DATABASE_VALUES.PAN_CARD_LOOKUP_ID ? (
                  <div className="row">
                    <div className="col-md-6">
                      <label className="LeftText f11 fw-semibold">
                        {commonLabels.SIGN_UP.PAN_CARD_NO}
                        <span className="errorText">*</span>
                      </label>
                      <div className="input-group bg-color">
                        <input
                          className="form-control text-uppercase"
                          id="registrationFormControlInput1"
                          type="text"
                          ref={register({ required: true })}
                          name="panNo"
                          placeholder={commonLabels.SIGN_UP.PAN_CARD_NO_PLACEHOLDER}
                          minLength="10"
                          maxLength="10"
                          autoComplete="off"
                          onChange={(e) => {
                            setValue("verifyPanNo", "");
                            clearErrors("verifyPanNo");
                            handleTextChange(e);
                          }}
                          onBlur={(e) => handleBlur(e)}
                        />
                      </div>
                      {_.get("panNo.type", errors) === "required" && (
                        <p className="errorText">
                          {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                        </p>
                      )}
                      {unmaskPanValueErr && (
                        <p className="errorText">
                          {commonLabels.VALIDATE_MESSAGE.ENTER_VALID_PAN_NUMBER}
                        </p>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="LeftText f11 fw-semibold">
                        {commonLabels.SIGN_UP.VERIFY_PAN_CARD_NO}
                        <span className="errorText">*</span>
                      </label>
                      <div className="input-group bg-color">
                        <input
                          className="form-control text-uppercase"
                          id="registrationFormControlInput1"
                          type="text"
                          ref={register({ required: true })}
                          name="verifyPanNo"
                          placeholder={
                            commonLabels.SIGN_UP.VERIFY_PAN_CARD_NO_PLACEHOLDER
                          }
                          onChange={checkValidity}
                          minLength="10"
                          maxLength="10"
                          autoComplete="off"

                        />
                      </div>
                      {_.get("verifyPanNo.type", errors) === "required" && (
                        <p className="errorText">
                          {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                        </p>
                      )}
                      {verifyPanNoFlag &&
                        _.get("verifyPanNo.type", errors) != "required" ? (
                        <p className="errorText">
                          {commonLabels.SIGN_UP.PAN_NO_AND_VERIFY_PAN_NO}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) :
                  // idTypeLabel === commonLabels.COMMON.DRIVING_LICENCE ? (
                  idTypeLookupId == commonLabels.DATABASE_VALUES.DL_LOOKUP_ID ? (
                    <div className="row">
                      <div className="col-md-6">
                        <label className="LeftText f11 fw-semibold">
                          {commonLabels.SIGN_UP.
                            DRIVING_LI_NO}
                          <span className="errorText">*</span>
                        </label>
                        <div className="input-group bg-color">
                          <input
                            className="form-control text-uppercase"
                            id="registrationFormControlInput1"
                            type="text"
                            ref={register({
                              required: true
                            })}
                            name="drivingLicenceNo"
                            placeholder={
                              commonLabels.SIGN_UP.DRIVING_LI_NO_PLACEHOLDER
                            }
                            maxLength="16"
                            onChange={(e) => {
                              setValue("verifyDrivingLicenceNo", "");
                              clearErrors("verifyDrivingLicenceNo");
                              // clearErrors("drivingLicenceNo");
                              handleTextChange(e);
                            }}
                            autoComplete="off"

                            onBlur={(e) => handleBlur(e)}
                          />
                        </div>
                        {_.get("drivingLicenceNo.type", errors) === "required" && (
                          <p className="errorText">
                            {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                          </p>
                        )}
                        {/* {unmaskDrivingLicenceValueErr && (
                          <p className="errorText">
                            {
                              commonLabels.VALIDATE_MESSAGE
                                .ENTER_VALID_DRIVING_LICENCE_NUMBER
                            }
                          </p>
                        )} */}
                      </div>
                      <div className="col-md-6">
                        <label className="LeftText f11 fw-semibold">
                          {commonLabels.SIGN_UP.VERIFY_DRIVING_LI_NO}
                          <span className="errorText">*</span>
                        </label>
                        <div className="input-group bg-color">
                          <input
                            className="form-control text-uppercase"
                            id="registrationFormControlInput1"
                            type="text"
                            ref={register({ required: true })}
                            name="verifyDrivingLicenceNo"
                            placeholder={
                              commonLabels.SIGN_UP.VERIFY_DRIVING_LI_NO_PLACEHOLDER
                            }
                            onChange={checkValidity}
                            maxLength="16"
                            autoComplete="off"

                          />
                        </div>
                        {_.get("verifyDrivingLicenceNo.type", errors) ===
                          "required" && (
                            <p className="errorText">
                              {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                            </p>
                          )}
                        {verifyDrivingLicenceFlag &&
                          _.get("verifyDrivingLicenceNo.type", errors) != "required" ? (
                          <p className="errorText">
                            {commonLabels.SIGN_UP.LINCENCE_NO_AND_VERIFY_LINCENCE_NO}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

              <div className="col-md-12 background-field mt-3">
                <span className="text-primary f12 font-weight">
                  {commonLabels.COMMON.SECURITY_QUESTIONS_NOTE}
                </span>
              </div>
              <div className="col-md-12">
                {Object.entries(questions)
                  .sort()
                  .map(([key, value]) => {
                    return (
                      <div className="row" key={key}>
                        <div className="col-md-6 d-flex align-items-center">
                          <label className="f12 fw-semibold">
                            {value}
                            <span className="errorText">*</span>
                          </label>
                        </div>
                        {key === "SQ3" ? (
                          <div className="col-md-6 otherFormMarginBottom">
                            <div className="input-group bg-color">
                              <input
                                type="text"
                                className="form-control text-uppercase"
                                name={key}
                                id="sq"
                                ref={register({ required: true })}
                                onBlur={(e) => e.target.value = e.target.value.trim()}
                                autoComplete="off"
                              />
                            </div>
                            {_.get(key + ".type", errors) === "required" && (
                              <p className="errorText">
                                {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                              </p>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                        {key === "SQ1" || key === "SQ4" ? (
                          <div className="col-md-6 otherFormMarginBottom">
                            <div className="input-group">
                              {/* <input
                              type="text"
                              className="form-control"
                              maxLength={4}
                              name={key}
                              id="sq"
                              ref={register({
                                required: true,
                                pattern: numberValidation,
                              })}
                            /> */}

                              <select
                                className="form-select  bg-color"
                                name={key}
                                ref={register({ required: true })}
                                maxLength={4}
                                id="sq"
                              >
                                <option key={0} value="">
                                  {commonLabels.SIGN_UP.SELECT}
                                </option>
                                {getYearList()}
                              </select>
                            </div>
                            {_.get(key + ".type", errors) === "required" && (
                              <p className="errorText">
                                {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                              </p>
                            )}
                            {_.get(key + ".type", errors) === "pattern" && (
                              <p className="errorText">
                                {
                                  commonLabels.VALIDATE_MESSAGE
                                    .PLEASE_ENTER_VALID_INPUT
                                }
                              </p>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {key === "SQ2" ? (

                          <div className="col-md-6 otherFormMarginBottom">
                            <div className="input-group">
                              <select
                                className="form-select  bg-color"
                                name={key}
                                ref={register({ required: true })}
                                id="sq"
                              >
                                <option key={0} value="">
                                  {commonLabels.SIGN_UP.SELECT}
                                </option>
                                {boardsList && boardsList.length > 0 && boardsList.map((ele, ind) => {
                                  return (
                                    <option key={ind++} value={ele.id}>
                                      {ele.label}
                                    </option>
                                  );
                                })
                                }
                              </select>
                            </div>
                            {_.get(key + ".type", errors) === "required" && (
                              <p className="errorText">
                                {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                              </p>
                            )}

                          </div>

                        ) : (
                          ""
                        )}

                        {
                          key === "SQ5" ||
                            key === "SQ6" ? (
                            <div className="col-md-6 otherFormMarginBottom">
                              <div className="input-group bg-color">
                                <input
                                  type="text"
                                  className="form-control text-uppercase"
                                  name={key}
                                  id="sq"
                                  ref={register({
                                    required: true,
                                    pattern: key === "SQ6" && securityQuestionRegex,
                                  })}
                                  onBlur={(e) => e.target.value = e.target.value.trim()}
                                  autoComplete="off"
                                  maxLength={50}
                                />
                              </div>
                              {_.get(key + ".type", errors) === "required" && (
                                <p className="errorText">
                                  {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                                </p>
                              )}
                              {_.get(key + ".type", errors) === "pattern" && (
                                <p className="errorText">
                                  {
                                    commonLabels.VALIDATE_MESSAGE
                                      .PLEASE_ENTER_VALID_INPUT
                                  }
                                </p>
                              )}
                            </div>
                          ) : (
                            ""
                          )}
                      </div>
                    );
                  })}
              </div>

              {verifyOTPFlagRegistrationEmail &&
                verifyOTPFlagRegistrationMobile && (
                  <div className="col-md-12 background-field mt-3">
                    <span className="text-primary f12">
                      {commonLabels.COMMON.CAPTCHA_SECTION}
                    </span>
                  </div>
                )}

              {verifyOTPFlagRegistrationEmail &&
                verifyOTPFlagRegistrationMobile ? (
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 background-field">
                    {captchaId !== 0 && matchingBaseUrl ? (
                      <img
                        src={captchaImageUrl}
                        id="registrationFormControlInput8"
                      />
                    ) : captchaId !== 0 ? (
                      <img
                        src={`/oas/api/v1/otps/${captchaId}`}
                        id="registrationFormControlInput8"
                      />
                    ) : (
                      ""
                    )}
                    <span className="ms-3">
                      {" "}
                      <i
                        className="fa fa-refresh fa-lg cursor-pointer"
                        onClick={() => {
                          dispatch(generateCaptcha());
                        }}
                      />
                    </span>
                    <label className="LeftText fw-semibold">
                      {commonLabels.VALIDATE_MESSAGE.CAPTCHA_ENTER_COMMAND}
                      <span className="errorText">*</span>
                    </label>
                    <div className="input-group bg-color">
                      <input
                        type="text"
                        className="form-control"
                        id="registrationFormControlInput9"
                        name="enteredCaptcha"
                        autoComplete="off"
                        ref={register({ required: true })}
                        maxLength={6}
                      />
                    </div>
                    {_.get("enteredCaptcha.type", errors) === "required" && (
                      <p className="errorText">
                        {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              
              {/* Declaration */}
              <div>
      <div className="flex">
        <input
          className="form-check-input mt-2 f11 regis-declaration-checkbox"
          type="checkbox"
          checked={isAgreed}
          onChange={handleCheckboxChange}
        />
        <p className="regis-declaration">I Agree</p>
      </div>

      <h6 className="mb-0">
        <label className="LeftText f12 font-weight">
          {commonLabels.PHOTO_SIGNATURE.REGISTRATION_CONFIRMATION_NOTE}
        </label>
        <label className="f11 mt-1 text-blue">
          {commonHILabels.PHOTO_SIGNATURE.CONFIRMATION_NOTE_1}
        </label>
      </h6>
    </div>


              <div className="row mb8">
                <div className="form-group col-md-12">
                  <button
                    type="submit"
                    className=" btn btn-primary custom_button  me-1 mt-1 register-btn button-gradient"
                    disabled={(!allFieldsFilled) || (!errors) || (unmaskAadharValueErr) || (unmaskPanValueErr) || (verifyAadharFlag) || (verifyPanNoFlag) || (verifyDrivingLicenceFlag) || (verifyCandidateMotherNameFlag) || (verifyCandidateFatherNameFlag) || (verifyCandidateNameFlag) || (verifyGenderFlag) || (verifyCandidateDOBFlag) || !isAgreed } 
                  >
                    {commonLabels.BUTTONS.REGISTER}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-5 mt-4 box-container">
          <p className="text-center ms-4 mb-2">
            <span className="home-instructions-steps">
              {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE}
            </span>
          </p>
          <div className="dotted-line m-1"></div>
          <p className="text-start ml38 d-flex align-items-start">
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_ONE}
              </span><br />
              <span>
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_ONE}
              </span>
              <br />
              <div className="space">
                <span >
                  {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_ONE}
                </span>
              </div>
            </span>
          </p>

          <p className="text-start ml38 d-flex align-items-start">
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_TWO}
              </span><br />
              <span>
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_TWO}
              </span>
              <br />
              <div className="space">
                <span>
                  {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_TWO}
                </span>
              </div>
            </span>
          </p>

          <p className="text-start ml38 d-flex align-items-start">
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_THREE}
              </span><br />
              <span>
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_THREE}
              </span>
              <br />
              <div className="space">
                <span>
                  {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_THREE}
                </span>
              </div>
            </span>
          </p>

          <p className="text-start ml38 d-flex align-items-start">
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_FOUR}
              </span><br />
              <span>
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_FOUR}
              </span>
              <br />
              <div className="space" >
                <span>
                  {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_FOUR}
                </span>
              </div>
            </span>
          </p>

          <p className="text-start ml38 d-flex align-items-start">
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_FIVE}
              </span><br />
              <span>
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_FIVE}
              </span>
              <br />
              <div className="space" >
                <span>
                  {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_FIVE}
                </span>
              </div>
            </span>
          </p>

          <p className="text-start ml38 d-flex align-items-start">
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_SIX}
              </span><br />
              <span>
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_SIX}
              </span>
              <br />
              <div className="space" >
                <span>
                  {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_SIX}
                </span>
              </div>
            </span>
          </p>

          <p className="text-start ml38 d-flex align-items-start">
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_SEVEN}
              </span><br />
              <span>
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_SEVEN}
              </span>
              <br />
              <div className="space" >
                <span>
                  {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_SEVEN}
                </span>
              </div>
            </span>
          </p>

          <p className="text-start ml38 d-flex align-items-start">
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_EIGHT}
              </span><br />
              <span>
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_EIGHT}
              </span>
              <br />
              <div className="space" >
                <span>
                  {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_EIGHT}
                </span>
              </div>
            </span>
          </p>

          <p className="text-start ml38 d-flex align-items-start">
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_NINE}
              </span><br />
              <span>
                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_NINE}
              </span>
              <br />
              <div className="space" >
                <span>
                  {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_NINE}
                </span>
              </div>
              <span>
                {Object.entries(questions)
                  .sort()
                  .map(([key, value]) => {
                    return (
                      <div>
                        {value}
                      </div>
                    );
                  })}
              </span>
            </span>
          </p>

          {/* <p className="text-start ml38 mb-1">
            <span className="f20 text-dark me-2">•</span>
            <span className="text-dark">
              {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_1}
            </span><br/>
            <span>
              {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_1}
            </span>
          </p>
          <p className="text-start ml38 mb-2">
            <span className="f20 text-dark me-2">•</span>
            <span className="text-dark">
              {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2}
            </span><br/>
            <span>
              {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2}
            </span>
          </p>
          <p className="text-start ml70 mb-2">
            <span className="text-dark">
              {numberformat["1"]}.&nbsp;
              {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_1}
            </span>
            <span>
              {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_1}
            </span>
          </p>
          <p className="text-start ml70 mb-2">
            <span className="text-dark">
              {numberformat["2"]}.&nbsp;
              {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_2}
            </span>
            <span>
              {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_2}
            </span>
          </p>
          <p className="text-start ml70 mb-2">
            <span className="text-dark">
              {numberformat["3"]}.&nbsp;
              {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_3}
            </span>
            <span>
              {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_3}
            </span>
          </p>
          <p className="text-start ml70 mb-2">
            <span className="text-dark">
              {numberformat["4"]}.&nbsp;
              {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_4}
            </span>
            <span>
              {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_4}
            </span>
          </p>
          <p className="text-start ml70 mb-2">
            <span className="text-dark">
              {numberformat["5"]}.&nbsp;
              {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_5}
            </span>
            <span>
              {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_5}
            </span>
          </p>
          <p className="text-start ml70 mb-2">
            <span className="text-dark">
              {numberformat["6"]}.&nbsp;
              {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_6}
            </span>
            <span>
              {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_6}
            </span>
          </p>
          <p className="text-start ml70 mb-2">
            <span className="text-dark">
              {numberformat["7"]}.&nbsp;
              {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_7}
            </span>
            <span>
              {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_7}
            </span>
          </p>
          <p className="text-start ml70">
            <span className="text-dark">
              {numberformat["8"]}.&nbsp;
              {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_8}
            </span>
            <span>
              {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_8}
            </span>
          </p>
          <p className="text-start ml38 d-flex align-items-start mb-2">
            <span className="f20 text-dark me-2 flex-shrink-0">•</span>
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_3}
              </span>
              <span>
                {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_3}
              </span>
            </span>
          </p>
          <p className="text-start ml38 d-flex align-items-start mb-2">
            <span className="f20 text-dark me-2 flex-shrink-0">•</span>
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_4}
              </span>
              <span>
                {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_4}
              </span>
            </span>
          </p>
          <p className="text-start ml38 d-flex align-items-start mb-2">
            <span className="f20 text-dark me-2 flex-shrink-0">•</span>
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_5}
              </span>
              <span>
                {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_5}
              </span>
            </span>
          </p>
          <p className="text-start ml38 d-flex align-items-start">
            <span className="f20 text-dark me-2 flex-shrink-0">•</span>
            <span className="mt-1">
              <span className="text-dark">
                {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_6}
              </span>
              <span>
                {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_6}
              </span>
            </span>
          </p> */}

        </div>

        {/* PAN and DL Secton */}

        {
          showModal && <Modal size="s" show={showModal} onHide={toggleModal} backdrop='static' scrollable>
            <Modal.Header className="custom-modal-header logout_heading">
              <Modal.Title className="logout_title">{commonLabels.Important_Note}</Modal.Title>
              <button
                type="button"
                className="ms-auto logout_close"
                aria-label="Close"
                onClick={toggleModal}
              >X</button>
            </Modal.Header>
            <Modal.Body>

              <p className="panMessage">{commonLabels.SIGN_UP.CHARGES_FOR_PAN_AND_DRIVING_LICENSE_MSG_1}</p>

              <hr />
              <p className="panMessage">{commonLabels.SIGN_UP.CHARGES_FOR_PAN_AND_DRIVING_LICENSE_MSG_2}</p>
              <button className="panButton" onClick={toggleModal} >Ok</button>
            </Modal.Body>
          </Modal>
        }
    <Modal size="xl" show={showInstructionsModal} onHide={toggleModal} backdrop='static' scrollable>
          <Modal.Header className="custom-modal-header logout_heading">
            <Modal.Title className="logout_title">{commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS}</Modal.Title>
            <button
              type="button"
              className="ms-auto logout_close"
              aria-label="Close"
              onClick={toggleModal}
            >X</button>
          </Modal.Header>
          <Modal.Body className="pt-1">
            <div className="">
              {digilockerFlg === 1 &&
                <div className="col-sm-12 col-md-12">
                  <p className="text-center ms-4 mb-2">
                    <span className="home-instructions-steps">
                      {commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS}
                    </span>
                  </p>
                  <div className="dotted-line m-1"></div>
                  <p className="text-start ml38 d-flex align-items-start">
                    <span className="mt-1">
                      <span className="text-dark">
                        {commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE}
                      </span><br />
                    </span>
                  </p>
                  <p className="text-start ml38 d-flex align-items-start">
                    <span className="mt-1">
                      <span className="text-dark">
                        {commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_QUESTION_ONE}
                      </span><br />
                      <span>
                        {commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_ONE_1}
                      </span>
                      <a href={commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_ONE_2} target="_blank" rel="noopener noreferrer">
                        <span>
                          {commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_ONE_2}
                        </span>
                      </a>
                      <span>
                        {commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_ONE_3}
                      </span>
                      <br />
                      <div className="space" >
                        <span>
                          {commonHILabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_ONE_1}
                        </span>
                        <a href={commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_ONE_2} target="_blank" rel="noopener noreferrer">
                          <span>
                            {commonHILabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_ONE_2}
                          </span>
                        </a>
                        <span>
                          {commonHILabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_ONE_3}
                        </span>
                      </div>
                    </span>
                  </p>
                  <p className="text-start ml38 d-flex align-items-start">
                    <span className="mt-1">
                      <span className="text-dark">
                        {commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_QUESTION_TWO}
                      </span><br />
                      <span>
                        {commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_TWO}
                      </span>
                      <br />
                      <div className="space" >
                        <span>
                          {commonHILabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_TWO}
                        </span>
                      </div>
                    </span>
                  </p>
                  <p className="text-start ml38 d-flex align-items-start">
                    <span className="mt-1">
                      <span className="text-dark">
                        {commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_QUESTION_THREE}
                      </span><br />
                      <span>
                        {commonLabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_THREE}
                      </span>
                      <br />
                      <div className="space" >
                        <span>
                          {commonHILabels.HOME_INSTRUCTIONS.DIGILOCKER_INSTRUCTIONS_NOTE_ANSWER_THREE}
                        </span>
                      </div>
                    </span>
                  </p>
                </div>
              }

              <div className="col-sm-12 col-md-12 mt-4">
                <p className="text-center ms-4 mb-2">
                  <span className="home-instructions-steps">
                    {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE}
                  </span>
                </p>
                <div className="dotted-line m-1"></div>
                <p className="text-start ml38 d-flex align-items-start">
                  <span className="mt-1">
                    <span className="text-dark">
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_ONE}
                    </span><br />
                    <span>
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_ONE}
                    </span>
                    <br />
                    <div className="space" >
                      <span>
                        {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_ONE}
                      </span>
                    </div>
                  </span>
                </p>

                <p className="text-start ml38 d-flex align-items-start">
                  <span className="mt-1">
                    <span className="text-dark">
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_TWO}
                    </span><br />
                    <span>
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_TWO}
                    </span>
                    <br />
                    <div className="space" >
                      <span>
                        {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_TWO}
                      </span>
                    </div>
                  </span>
                </p>

                <p className="text-start ml38 d-flex align-items-start">
                  <span className="mt-1">
                    <span className="text-dark">
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_THREE}
                    </span><br />
                    <span>
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_THREE}
                    </span>
                    <br />
                    <div className="space" >
                      <span>
                        {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_THREE}
                      </span>
                    </div>
                  </span>
                </p>

                <p className="text-start ml38 d-flex align-items-start">
                  <span className="mt-1">
                    <span className="text-dark">
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_FOUR}
                    </span><br />
                    <span>
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_FOUR}
                    </span>
                    <br />
                    <div className="space" >
                      <span>
                        {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_FOUR}
                      </span>
                    </div>
                  </span>
                </p>

                <p className="text-start ml38 d-flex align-items-start">
                  <span className="mt-1">
                    <span className="text-dark">
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_FIVE}
                    </span><br />
                    <span>
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_FIVE}
                    </span>
                    <br />
                    <div className="space" >
                      <span>
                        {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_FIVE}
                      </span>
                    </div>
                  </span>
                </p>

                <p className="text-start ml38 d-flex align-items-start">
                  <span className="mt-1">
                    <span className="text-dark">
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_SIX}
                    </span><br />
                    <span>
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_SIX}
                    </span>
                    <br />
                    <div className="space" >
                      <span>
                        {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_SIX}
                      </span>
                    </div>
                  </span>
                </p>

                <p className="text-start ml38 d-flex align-items-start">
                  <span className="mt-1">
                    <span className="text-dark">
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_SEVEN}
                    </span><br />
                    <span>
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_SEVEN}
                    </span>
                    <br />
                    <div className="space" >
                      <span>
                        {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_SEVEN}
                      </span>
                    </div>
                  </span>
                </p>

                <p className="text-start ml38 d-flex align-items-start">
                  <span className="mt-1">
                    <span className="text-dark">
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_EIGHT}
                    </span><br />
                    <span>
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_EIGHT}
                    </span>
                    <br />
                    <div className="space" >
                      <span>
                        {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_EIGHT}
                      </span>
                    </div>
                  </span>
                </p>

                <p className="text-start ml38 d-flex align-items-start">
                  <span className="mt-1">
                    <span className="text-dark">
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_QUESTION_NINE}
                    </span><br />
                    <span>
                      {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_NINE}
                    </span>
                    <br />
                    <div className="space" >
                      <span>
                        {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS_NOTE_ANSWER_NINE}
                      </span>
                    </div>
                    <span>
                      {Object.entries(questions)
                        .sort()
                        .map(([key, value]) => {
                          return (
                            <div>
                              {value}
                            </div>
                          );
                        })}
                    </span>
                  </span>
                </p>
              </div>
            </div>
            <button className="panButton" onClick={toggleModal} >Close</button>
          </Modal.Body>
        </Modal>
      </form >
    );
}
export default Registration;
